import React, { useContext } from "react";
import { Box } from "Components/Base/Layout/Box";
import {
  PROP_TYPE_PROGRAM_COURSE,
  PROP_DEFAULT_PROGRAM_COURSE,
} from "../../../../propTypes";
import LangContext from "../../../../langContext";
import { StyledSurveyLinkContainer } from "../../style";
import Description from "../../../Description";
import { StyledEmptyStars } from "../../../../functions";
import config from "lib/config";

const ProgramTypeSurveyToComplete = (props) => {
  const languageContext = useContext(LangContext);
  const { course, isPreview } = props;

  return (
    <div>
      <StyledEmptyStars />
      <Description>
        <p>{languageContext(course.itemDescription)}</p>
      </Description>
      {course.mandatorySurveySent && !course.completed && (
        <div>
          <span className="tag-warning">
            {languageContext("surveyHasBeenSent")}
          </span>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-center"
            width="100%"
          >
            {!isPreview && (
              <a
                className="button-transparent link"
                target="_blank"
                rel="noopener noreferrer"
                href={`${config.urlRoot}np/survey.aspx?token=${course.surveyTokenID}`}
              >
                {languageContext("goToSurvey")}
              </a>
            )}
          </Box>
        </div>
      )}
    </div>
  );
};

ProgramTypeSurveyToComplete.propTypes = {
  course: PROP_TYPE_PROGRAM_COURSE,
};

ProgramTypeSurveyToComplete.defaultProps = {
  course: PROP_DEFAULT_PROGRAM_COURSE,
};

export default ProgramTypeSurveyToComplete;
